// extracted by mini-css-extract-plugin
module.exports = {"top-logo":"index_top-logo_2Qk1z","dropdown":"index_dropdown_4Fnfq"};